import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Container, Grid, Typography, useMediaQuery } from '@mui/material'
import { useDispatch } from 'react-redux'
import CookiesStorageService from '../../services/CookiesStorageService'
import AppRoutes from '../../services/AppRoutes'
import ResponsiveAppBar from '../../components/ResponsiveAppBar'
import { userAuthValidateToken } from '../../redux/features/userAuth/userAuthThunk'
import { getFirstAndSecondCharacterOnly } from '../../utils/helpers'
import orgariseLogo from '../../images/OrgariseLogoBlack.png'
import landingInfo from '../../images/landing-info.icon.png'
import landingModules from '../../images/landing-modules-icon.png'
import UserInfoSide from './UserInfoSide'
import ModulesSide from './ModulesSide'
import UseTranslation from '../../hooks/UseTranslation'

const Index = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const { t } = UseTranslation()

  useEffect(() => {
    dispatch(userAuthValidateToken())

    if (CookiesStorageService.getUserModules()?.length === 1) {
      const userModuleName = CookiesStorageService.getUserModules()[0].name
      if (userModuleName === 'Eds') {
        window.location.href = process.env.REACT_APP_EDS_FRONTEND_URL
      } else if (userModuleName === 'Recruitment') {
        window.location.href = process.env.REACT_APP_RECRUITMENT_FRONTEND_URL
      } else if (userModuleName === 'Self Service') {
        window.location.href = `${process.env.REACT_APP_SELF_FRONTEND_URL}`
      } else if (userModuleName === 'core') {
        window.location.href = `${process.env.REACT_APP_CORE_FRONTEND_URL}/`
      } else if (userModuleName === 'Admin') {
        history.push(AppRoutes.landing)
      }
    }
  }, [])
  return (
    <Box sx={styles.root}>
      <ResponsiveAppBar />
      <Container sx={styles.container} maxWidth='xl'>

        <Box sx={styles.titleBox}>
          <Box sx={styles.nameSection}>
            <Box sx={styles.titleShortName}>
              {getFirstAndSecondCharacterOnly(CookiesStorageService.getUserName())}
            </Box>
            <Typography>{t?.Welcome} {
            isXsScreen ? ((CookiesStorageService.getUserName())?.trim()?.split(' ')?.slice(0, 2)
              ?.join(' ') || 'user') : (CookiesStorageService.getUserName() || 'user')
              }</Typography>
          </Box>

          <img src={orgariseLogo} alt='ORGARISE' />
        </Box>

        <Grid container sx={styles.DataContainer} spacing={2}>
          <Grid item sm={12} md={8} >
            <Box sx={styles.sideTitle}>
              <img src={landingInfo} alt='admin icon' />
              <Typography>{t?.['User Information']}</Typography>
            </Box>

            <UserInfoSide />
          </Grid>

          <Grid item sm={12} md={4}>
            <Box sx={styles.sideTitle}>
              <img src={landingModules} alt='admin icon' />
              <Typography>{t?.['Please Select One Of Your Modules To Login To']}</Typography>
            </Box>

            <ModulesSide />
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const styles = {
  root: {
    backgroundColor: 'white',
    minHeight: '100vh',
  },
  container: {
    paddingBottom: { xs: '10px', md: '0px' },
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '-10px',
    marginBottom: { xs: '10px', sm: '30px' },
    paddingBottom: { xs: '10px', sm: '15px' },
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    '& img': {
      display: { xs: 'none', sm: 'block' },
      maxWidth: { xs: '80px', sm: '180px', md: '220px' },
      width: '100%',
      height: { xs: '30px', sm: '57px' },
    },

  },
  nameSection: {
    alignItems: 'center',
    display: 'flex',
    m: { xs: '15px 0 5px 0', sm: '0px' },
    '& p': {
      fontSize: { xs: '16px', sm: '28px' },
      fontFamily: 'Avenir-bold',
      textTransform: 'capitalize',
      width: 'max-content',
    },
  },
  titleShortName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: { xs: '40px', sm: '60px' },
    height: { xs: '40px', sm: '60px' },
    color: 'white',
    borderRadius: '12px',
    fontSize: { xs: '20px', sm: '28px' },
    fontFamily: 'Avenir-bold',
    textTransform: 'uppercase',
    backgroundColor: '#2A374A',
    marginRight: { xs: '5px', sm: '20px' },
  },
  sideTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'normal', md: 'flex-start' },
    marginLeft: { xs: '0px', sm: '20px' },
    marginBottom: { xs: '10px', sm: '30px' },
    '& img': {
      marginRight: { xs: '10px', sm: '18px' },
      width: { xs: '20px', sm: '30px' },
    },
    '& p': {
      fontSize: { xs: '14px', sm: '18px' },
    },
  },
  DataContainer: {
    flexDirection: { xs: 'column', md: 'row' },
    mb: { xs: '10px', sm: 'unset' },
    marginTop: { xs: '-3px', sm: '0px' },
  },
}

export default Index
